var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.64658V3.09058H18V5.09058H6V3.09058H4V9.64758C2.81 10.3406 2 11.6166 2 13.0906V17.0906C2 17.3558 2.10536 17.6101 2.29289 17.7977C2.48043 17.9852 2.73478 18.0906 3 18.0906H4V22.0906H6V18.0906H18V22.0906H20V18.0906H21C21.2652 18.0906 21.5196 17.9852 21.7071 17.7977C21.8946 17.6101 22 17.3558 22 17.0906V13.0906C22 11.6166 21.189 10.3406 20 9.64658ZM11 9.09058H6V7.09058H11V9.09058ZM18 9.09058H13V7.09058H18V9.09058Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.c739a43ad24ef541f4dd253e57cdd0c2.svg";
export { ForwardRef as ReactComponent };